import { devices } from 'src/stores/lists/devices';
import { get } from 'svelte/store';

import { encryptionKeyDefault } from 'src/constants';
import { AndroidHttpClient } from './utils/android-http-client';

const shellyHttpClient = new AndroidHttpClient();

export async function web_ready_android() {
	console.log('called `web_ready` to native Android');
	const res = await shellyHttpClient.get('shelly://web_ready/');
	return res;
}

export async function login_mobile_android(email, user_api_url, lang) {
	const res = await shellyHttpClient.post(
		`shelly://login/?username=${encodeURIComponent(
			email,
		)}&user_files_url=${user_api_url}/shelly_files/assets/&lang=${lang}`,
	);
	return res.data.isok;
}

export async function logout_mobile_android(email) {
	const res = await shellyHttpClient.post(`shelly://logout/?username=${encodeURIComponent(email)}`);
	return res;
}

export async function logout_all_android() {
	const res = await shellyHttpClient.post('shelly://logout_all');
	return res;
}

export async function account_switch_mobile_android(email) {
	const res = await shellyHttpClient.post(
		`shelly://account_switched/?username=${encodeURIComponent(email)}`,
	);
	return res;
}

/**
 * Hands a camera's plaintext `master_key` to native secure storage, mapped by
 * account email + device id, so push notifications can decrypt preview images.
 *
 * @param email - Normalised (lowercased) account email the key belongs to.
 * @param deviceID - The camera's device id (MAC).
 * @param masterKey - The base64 `master_key`.
 */
export async function camera_master_key_android(email: string, deviceID: string, masterKey: string) {
	const res = await shellyHttpClient.post(
		`shelly://camera_master_key/?username=${encodeURIComponent(
			email,
		)}&deviceID=${encodeURIComponent(deviceID)}&master_key=${encodeURIComponent(masterKey)}`,
	);
	return res;
}

export async function change_lang_android(lang) {
	const res = await shellyHttpClient.post(`shelly://lang_changed/?lang=${lang}`);
	return res;
}

export async function init_info_mobile_android() {
	const res = await shellyHttpClient.get('shelly://info/');
	return res;
}

export async function init_wearables_android() {
	const res = await shellyHttpClient.get('shelly://wearables_select');
	return res;
}

export async function init_discover_devices_android() {
	if (import.meta.env.DEV) {
		console.log('PLS DISCOVER DEVICES');
	}
	const res = await shellyHttpClient.get('shelly://discover_devices/');
	return res;
}

export function search_shelly_wifi_devices_android() {
	shellyHttpClient.get('shelly://search_shelly_wifi_devices');
}

export async function search_bluetooth_devices_android() {
	if (import.meta.env.DEV) {
		console.log('%csearching bluetooth devices Android Start', 'color: green; font-size: 14px;');
	}
	const res = await shellyHttpClient.get('shelly://search_bluetooth_devices/');
	return res;
}

export async function stop_bluetooth_search_android() {
	if (import.meta.env.DEV) {
		console.log('%csearching bluetooth devices Android Stop', 'color: red; font-size: 14px;');
	}
	const res = await shellyHttpClient.get('shelly://stop_bluetooth_discovery/');
	return res;
}

export async function update_denied_android() {
	console.log("Android command 'updateDenied'", 'c%Stop', 'color: orange, font-size: 14px');
	const res = await shellyHttpClient.get('shelly://include_bluetooth_device/?command=updateDenied');
	return res;
}

export async function bluetooth_device_update_android() {
	console.log("Android command 'update'", 'c%Stop', 'color: orange, font-size: 14px');
	const res = await shellyHttpClient.get('shelly://include_bluetooth_device/?command=update');
	return res;
}

export async function enable_device_beacon_android(mac) {
	console.log("Android command 'enableBeacon'", 'c%Start', 'color: orange, font-size: 14px');
	const res = await shellyHttpClient.get(
		`shelly://include_bluetooth_device/?deviceID=${encodeURIComponent(mac)}&command=enableBeacon`,
	);
	return res;
}

export async function disconnect_from_device_android() {
	console.log('disconnect from device android');
	const res = await shellyHttpClient.get('shelly://include_bluetooth_device/?command=disconnect');
	return res;
}

export async function abort_connection_android() {
	const res = await shellyHttpClient.get('shelly://include_bluetooth_device/?command=abortConnecting');
	return res;
}

export async function include_ble_android(mac: string, command: string, pass: string) {
	console.log('asking for "' + command + '" cmd for device ' + mac);
	if (typeof mac !== 'undefined') {
		const res = await shellyHttpClient.get(
			`shelly://include_bluetooth_device/?deviceID=${encodeURIComponent(
				mac,
			)}&command=${encodeURIComponent(command)}&pass=${encodeURIComponent(pass)}`,
		);
		return res;
	} else {
		const res = await shellyHttpClient.get(
			`shelly://include_bluetooth_device/?command=${encodeURIComponent(
				command,
			)}&pass=${encodeURIComponent(pass)}`,
		);
		return res;
	}
}

export async function include_device_android(
	mac?: string,
	command?: string,
	ssid?: string,
	pass?: string,
) {
	/**	include_device_android(inclusionData.selected.mac,'include',inclusionData.wifi.ssid,
					inclusionData.wifi.pass) */
	if (import.meta.env.DEV) {
		console.log(
			'%cinclude bluetooth android',
			'color: orange; font-size: 14px; font-family:Roboto',
			mac,
			command,
			ssid,
			pass,
		);
	}
	if (typeof ssid !== 'undefined' && typeof pass !== 'undefined') {
		const res = await shellyHttpClient.get(
			`shelly://include_bluetooth_device/?deviceID=${encodeURIComponent(
				mac,
			)}&command=${encodeURIComponent(command)}&ssid=${encodeURIComponent(
				ssid,
			)}&pass=${encodeURIComponent(pass)}`,
		);
		return res;
	} else {
		const res = await shellyHttpClient.get(
			`shelly://include_bluetooth_device/?deviceID=${encodeURIComponent(
				mac,
			)}&command=${encodeURIComponent(command)}`,
		);
		return res;
	}
}

export function include_wifi_device(shellySSID: string, wifiSSID: string, wifiPass: string) {
	shellyHttpClient.get(
		`shelly://include_wifi_device/?shellySSID=${encodeURIComponent(
			shellySSID,
		)}&wifiSSID=${encodeURIComponent(wifiSSID)}&wifiPass=${encodeURIComponent(wifiPass)}`,
	);
}

export async function get_files_android(url) {
	try {
		const res = await shellyHttpClient.get(url);
		return { data: res.data, isok: true };
	} catch (error) {
		return { isok: false };
	}
}

export async function set_devices_data_android(user_data, devices) {
	try {
		const res = await shellyHttpClient.get(
			'shelly://device_list/?d=' +
				encodeURIComponent(JSON.stringify({ userdata: user_data, devices: devices })),
		);
		return { data: res.data, isok: true };
	} catch (error) {
		return { isok: false };
	}
}

export async function open_external_link_android(url) {
	try {
		const res = await shellyHttpClient.get('shelly://open_url/?url=' + encodeURIComponent(url));
		return { data: res.data, isok: true };
	} catch (error) {
		return { isok: false };
	}
}

export async function online_devices_android(count) {
	try {
		const res = await shellyHttpClient.get('shelly://online_devices/?c=' + count);
		return { data: res.data, isok: true };
	} catch (error) {
		return { isok: false };
	}
}

export async function open_amazon_linking_android(app_url: string, web_url: string) {
	try {
		const res = await shellyHttpClient.get(
			`shelly://amazon_link?app_url=${btoa(app_url)}&web_url=${btoa(web_url)}`,
		);
		return { data: res.data, isok: true };
	} catch (error) {
		return { isok: false };
	}
}

export async function get_wifi_android() {
	const res = await shellyHttpClient.get('shelly://get_wifi/');
	return res;
}

export async function disableAccessPoint_android() {
	const res = await shellyHttpClient.get(
		'shelly://include_bluetooth_device/?command=disableAccessPoint',
	);
	return res;
}

export async function disableBluetooth_android() {
	const res = await shellyHttpClient.get(
		'shelly://include_bluetooth_device/?command=disableBluetooth',
	);
	return res;
}

/**
 * Sends a control command to a Bluetooth device through the native
 * Android bridge. The per-device encryption key is read defensively so
 * call sites that pass an unknown / disconnected / not-yet-registered
 * deviceID don't crash on `undefined.key_enc`.
 */
export async function control_bluetooth_device_android(deviceID, command) {
	const encKey = get(devices)[deviceID]?.key_enc;
	shellyHttpClient.get(
		`shelly://control_bluetooth_device/?deviceID=${encodeURIComponent(
			deviceID,
		)}&command=${encodeURIComponent(command)}${
			encKey && encKey !== encryptionKeyDefault ? '&encKey=' + encodeURIComponent(encKey) : ''
		}`,
	);
}

export async function control_encrypt_bluetooth_device_android(deviceID, pass) {
	shellyHttpClient.get(
		`shelly://control_bluetooth_device/?deviceID=${encodeURIComponent(
			deviceID,
		)}&command=${encodeURIComponent('encrypt')}&pass=${encodeURIComponent(pass)}`,
	);
}

export async function control_bluetooth_motion_sensitivity_android(deviceID, sensitivity) {
	const encKey = get(devices)[deviceID]?.key_enc;
	shellyHttpClient.get(
		`shelly://control_bluetooth_device/?deviceID=${encodeURIComponent(deviceID)}&command=${encodeURIComponent(
			'setSensitivity',
		)}&sensitivity=${sensitivity}${
			encKey && encKey !== encryptionKeyDefault ? '&encKey=' + encodeURIComponent(encKey) : ''
		}`,
	);
}

/**
 * Sends a Bluetooth control command to an iOS device via the Shelly protocol.
 * @param {string} deviceID - Unique identifier of the Bluetooth device.
 * @param {string} command - Command to send to the device.
 * @param {string} param - Query parameter key to include in the request.
 * @param {string | number} value - Value associated with the query parameter.
 * * @returns {void}
 */
export function control_bluetooth_general_android(deviceID, command, param, value) {
	const encKey = get(devices)[deviceID]?.key_enc;
	shellyHttpClient.get(
		`shelly://control_bluetooth_device/?deviceID=${encodeURIComponent(
			deviceID,
		)}&command=${encodeURIComponent(command)}&${param}=${value}${
			encKey && encKey !== encryptionKeyDefault ? '&encKey=' + encodeURIComponent(encKey) : ''
		}`,
	);
}

export function control_bluetooth_motion_blind_time_android(deviceID, blind_time) {
	const encKey = get(devices)[deviceID]?.key_enc;
	shellyHttpClient.get(
		`shelly://control_bluetooth_device/?deviceID=${encodeURIComponent(
			deviceID,
		)}&command=${encodeURIComponent('setBlindTime')}&blindTime=${blind_time}${
			encKey && encKey !== encryptionKeyDefault ? '&encKey=' + encodeURIComponent(encKey) : ''
		}`,
	);
}

export function control_bluetooth_dw_min_angel_threshold_android(deviceID, minAngleThreshold) {
	const req = new XMLHttpRequest();
	const encKey = get(devices)[deviceID]?.key_enc;

	req.open(
		'GET',
		`shelly://control_bluetooth_device/?deviceID=${encodeURIComponent(
			deviceID,
		)}&command=${encodeURIComponent('setMinAngleThreshold')}&minAngleThreshold=${minAngleThreshold}${
			encKey && encKey !== encryptionKeyDefault ? '&encKey=' + encodeURIComponent(encKey) : ''
		}`,
	);
	req.send();
}

export async function rpc_over_ble_android(deviceID, command) {
	const res = await shellyHttpClient.get(
		`shelly://include_bluetooth_device/?deviceID=${encodeURIComponent(
			deviceID,
		)}&command=${encodeURIComponent(command)}`,
	);
	return res;
}

export async function send_brpc_android(deviceID: string, frame: string) {
	const res = await shellyHttpClient.get(
		`shelly://control_bluetooth_device/?deviceID=${encodeURIComponent(
			deviceID,
		)}&command=brpc&frame=${encodeURIComponent(frame)}`,
	);
	return res;
}

export async function authenticate_over_ble_android(deviceID, password) {
	const res = await shellyHttpClient.get(
		`shelly://include_bluetooth_device/?deviceID=${encodeURIComponent(
			deviceID,
		)}&command=${encodeURIComponent('setDigestPassword')}&pass=${password}`,
	);
	return res;
}

export function is_alexa_app_installed_android() {
	shellyHttpClient.get('shelly://is_alexa_installed');
}

export async function hapticFeedbackAndroid(event) {
	shellyHttpClient.get(`shelly://trigger_feedback_event?event_type=${event}`);
}

export function force_go_back(enable: boolean) {
	shellyHttpClient.get(`shelly://force_go_back?enabled=${enable}`);
}

/**
 * Draw the WebView under Android system bars (edge-to-edge).
 * Each flag is independent — status and navigation can be toggled separately.
 */
export function set_under_system_bars_android(underStatusBar: boolean, underNavigationBar: boolean) {
	shellyHttpClient.get(
		`shelly://under_system_bars/?underStatusBar=${underStatusBar}&underNavigationBar=${underNavigationBar}`,
	);
}

export function handle_error_on_upload_image() {
	shellyHttpClient.get('shelly://error_uploading_image');
}

export async function load_asset_android(url: string, md5?: string, timeout: number = 6000) {
	let requestUrl = `shelly://load_asset/?file=${encodeURIComponent(url)}`;

	if (md5) {
		requestUrl += `&md5=${encodeURIComponent(md5)}`;
	}

	const req = new XMLHttpRequest();
	req.open('GET', requestUrl);
	req.responseType = 'blob';
	req.timeout = timeout;
	return new Promise((resolve, reject) => {
		req.onload = async () => {
			if (req.status === 200) {
				const blob = req.response;

				/**
				 * Legacy support for the old native response format.
				 * For older versions of the native app that doesn't support load_asset,
				 * it returns status 200 but with `isok: false` JSON response.
				 *
				 * If the try-catch fails, it means the response is the desired JS format
				 * and we should resolve.
				 */
				try {
					const data = JSON.parse(await blob.text());
					if (data.isok === false) {
						reject(new Error('Failed to load asset'));
						return;
					}
				} catch {}

				resolve(blob);
			} else if (req.status === 404) {
				reject(new Error('ASSET_NOT_FOUND'));
			} else if (req.status === 501) {
				reject(new Error('NATIVE_ASSET_LOADING_NOT_SUPPORTED'));
			} else {
				reject(new Error('Failed to load asset'));
			}
		};
		req.onerror = () => {
			reject(new Error('Network error while loading asset'));
		};
		req.ontimeout = () => {
			reject(new Error('Request timeout while loading asset'));
		};
		req.send();
	});
}

export async function change_app_icon_android(iconName: string = '') {
	shellyHttpClient.get(`shelly://change_app_icon/?icon=` + iconName);
}

export async function showAndroidRateAppPopUp(command: 'inAppReview' | 'detailsPage') {
	const res = await shellyHttpClient.get('shelly://rate_app?command=' + command);
	return res;
}

export async function showBiometricAuthAndroid(
	title: string,
	subtitle: string,
	description: string,
	negativeButton: string,
) {
	const url = `shelly://biometric_auth/?title=${title}&subtitle=${subtitle}&description=${description}&negativeButton=${negativeButton}`;
	const res = await shellyHttpClient.get(url);
	return res;
}

export async function askForSecuritySettings() {
	const res = await shellyHttpClient.get('shelly://settings_security');
	return res;
}
